var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useRef, useState } from "react";
// Delay in ms
var LEAVE_DELAY = 200;
/**
 * Manage hover event, but let a small delay on leaving
 */
export var useDeferredOver = function () {
    var _a = __read(useState(false), 2), hover = _a[0], setHover = _a[1];
    var leaveDelay = useRef(-1);
    var onMouseEnter = function () {
        if (leaveDelay.current !== -1) {
            clearTimeout(leaveDelay.current);
            leaveDelay.current = -1;
        }
        setHover(true);
    };
    var onMouseLeave = function () {
        leaveDelay.current = setTimeout(function () {
            setHover(false);
        }, LEAVE_DELAY);
    };
    return { hover: hover, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave };
};
